module.exports = __webpack_public_path__ + "static/img/car3.0a128af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/car3.jpg
// module id = sj4d
// module chunks = 0